module.exports = __webpack_public_path__ + "img/google_play.4295f020.svg";